import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../../components/PageWrapper';
import { ScrollableNav } from '../../components/ScrollableNav';
import source from '../../markdown-content/getting-started.english.md';

const GETTING_STARTED_SECTIONS = (t: TFunction): Array<{ id: string; title: string }> => [
    {
        id: 'background',
        title: t('GETTING_STARTED_PAGE.BACKGROUND_TITLE'),
    },
    {
        id: 'overview',
        title: t('GETTING_STARTED_PAGE.OVERVIEW_TITLE'),
    },
    {
        id: '1CreatingEatonServiceAccountCredentialsApigee',
        title: t('GETTING_STARTED_PAGE.CREATING_EATON_SERVICE_ACCOUNT_CREDENTIALS_TITLE'),
    },
    {
        id: '2CreatingYourAbleEdgeOrganizationCredentials',
        title: t('GETTING_STARTED_PAGE.CREATING_ABLEEDGE_ORGANIZATION_CREDENTIALS_TITLE'),
    },
    {
        id: '3StartUsingTheAbleEdgeApi',
        title: t('GETTING_STARTED_PAGE.START_USING_ABLEEDGE_API_TITLE'),
    },
];

export const GettingStarted: React.FC = () => {
    const { t } = useTranslation();

    return (
        <PageWrapper title={t('GETTING_STARTED_PAGE.GETTING_STARTED_TITLE')}>
            <ScrollableNav sectionList={GETTING_STARTED_SECTIONS(t)} source={source} pageRoute="/gettingStarted" />
        </PageWrapper>
    );
};
